<template>
  <!-- 分区-报警列表 -->
  <div>
    <a-card style="width: 100%; text-align: center">
      <div class="table-page-search-wrapper">
        <a-form layout="inline" style="margin: 20px 0px 0px 20px">
          <a-row :gutter="12">
            <a-col :md="6" :sm="12">
              <a-form-item label="片区选择">
                <!-- <a-input v-model="query.msgAddress" placeholder="请输入片区" allow-clear /> -->
                <a-tree-select :tree-data="zoneTreeData" v-model="query.msgAddress" style="width: 100%"
                  :replace-fields="{ title: 'zoneName', key: 'id', value: 'zoneName', selectable: 'selectable' }"
                  :dropdown-style="{ maxHeight: '400px', overflow: 'auto' }" placeholder="请选择片区" allow-clear
                  :treeDefaultExpandedKeys="treeDefaultExpandedKeys" show-search
                treeNodeFilterProp="title"></a-tree-select>
              </a-form-item>
            </a-col>
            <a-col :md="6" :sm="12">
              <a-form-item label="报警指标">
                <a-input v-model="query.alarmType" placeholder="请输入报警指标" allow-clear />
              </a-form-item>
            </a-col>
            <a-col :md="6" :sm="12">
              <a-form-item label="报警级别">
                <a-select placeholder="请选择报警级别" v-model="query.alarmLevel" allow-clear>
                  <a-select-option value="报警"> 报警 </a-select-option>
                  <a-select-option value="预警"> 预警 </a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
            <a-col :md="6" :sm="12">
              <a-form-item label="处理状态">
                <a-select placeholder="请选择处理状态" v-model="query.isDispose" allow-clear>
                  <a-select-option :value="0"> 未处理 </a-select-option>
                  <a-select-option :value="1"> 已处理 </a-select-option>
                  <a-select-option :value="2"> 已忽略 </a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
            <a-col :md="6" :sm="12" style="display: flex">
              <a-form-item>
                <a-button type="primary" @click="queryList">查询</a-button>
              </a-form-item>
              <a-form-item style="margin-left: 12px">
                <a-button @click="resetList">重置</a-button>
              </a-form-item>
              <a-button type="danger" style="margin-left: 12px" @click="deleteSelectRow()">删除</a-button>
            </a-col>
          </a-row>
        </a-form>
      </div>
      <a-tabs
        :activeKey="query.sysTab"
        class="alarm-source-tabs"
        :animated="false"
        @change="handleTabChange"
      >
        
        <a-tab-pane :key="6" tab="双轨预警算法报警列表">
          <a-table
            v-if="query.sysTab === 6"
            rowKey="id"
            :scroll="{ x: 1800 }"
            :columns="dualTrackColumns"
            :data-source="list"
            :loading="dataListLoading"
            :row-class-name="(_record, index) => (index % 2 === 1 ? 'table-striped' : null)"
            :row-selection="{ selectedRowKeys: selectedRows, onChange: onSelectChange }"
            :pagination="pagination"
            bordered
            @change="pageChange"
          >
            <span slot="type" slot-scope="text">
              <span v-if="text == 0">报警</span>
              <span v-else>故障</span>
            </span>
            <span slot="actiontype" slot-scope="text">
              <a-tag color="rgb(255, 99, 71)" v-if="text == 0"> 未处理 </a-tag>
              <a-tag color="rgb(50, 205, 50)" v-else-if="text == 1"> 已处理 </a-tag>
              <a-tag color="#1890ff" v-else> 已忽略 </a-tag>
            </span>
            <span slot="malfunctionLevel" slot-scope="text">
              <a-tag color="rgb(255, 0, 0)" v-if="text == '报警'"> 报警 </a-tag>
              <a-tag color="rgb(255, 165, 0)" v-else-if="text == '预警'"> 预警 </a-tag>
            </span>
            <span slot="DualTrackOperation" slot-scope="text, record">
              <a @click="PublishTask(record)" :disabled="record.isDispose !== 0">处理</a>
              <a style="margin-left: 12px" :disabled="record.isDispose !== 0" @click="LoseSightOf(record.id)">忽略</a>
              <a style="margin-left: 12px" @click="goToDualTrackChart(record)">图表分析</a>
            </span>
          </a-table>
        </a-tab-pane>
        <a-tab-pane :key="2" tab="手动设置报警列表">
          <a-table
            v-if="query.sysTab === 2"
            rowKey="id"
            :scroll="{ x: 1800 }"
            :columns="columns"
            :data-source="list"
            :loading="dataListLoading"
            :row-class-name="(_record, index) => (index % 2 === 1 ? 'table-striped' : null)"
            :row-selection="{ selectedRowKeys: selectedRows, onChange: onSelectChange }"
            :pagination="pagination"
            bordered
            @change="pageChange"
          >
            <span slot="type" slot-scope="text">
              <span v-if="text == 0">报警</span>
              <span v-else>故障</span>
            </span>
            <span slot="actiontype" slot-scope="text">
              <a-tag color="rgb(255, 99, 71)" v-if="text == 0"> 未处理 </a-tag>
              <a-tag color="rgb(50, 205, 50)" v-else-if="text == 1"> 已处理 </a-tag>
              <a-tag color="#1890ff" v-else> 已忽略 </a-tag>
            </span>
            <span slot="malfunctionLevel" slot-scope="text">
              <a-tag color="rgb(255, 0, 0)" v-if="text == '报警'"> 报警 </a-tag>
              <a-tag color="rgb(255, 165, 0)" v-else-if="text == '预警'"> 预警 </a-tag>
            </span>
            <span slot="Operation" slot-scope="text, record">
              <a @click="PublishTask(record)" :disabled="record.isDispose !== 0">处理</a>
              <a style="margin-left: 12px" :disabled="record.isDispose !== 0" @click="LoseSightOf(record.id)">忽略</a>
            </span>
          </a-table>
        </a-tab-pane>
      </a-tabs>
      <task-modal ref="TaskModal" @handleOk="update"></task-modal>
      <a-modal title="处理报警" okText="处理" width="50%" :visible="showdeal" @ok="handleDealOk" @cancel="handleDealCancel">
        <a-form :form="form" :label-col="{ span: 5 }" :wrapper-col="{ span: 12 }">
          <a-form-item label="处理人">
            <a-input v-decorator="['disposeName', { rules: [{ required: true, message: '请输入处理人!' }] }]" />
          </a-form-item>
          <a-form-item label="报警描述">
            <a-input v-decorator="['alarmContent', { rules: [{ required: true, message: '请输入报警描述!' }] }]" />
          </a-form-item>
        </a-form>
      </a-modal>
    </a-card>
  </div>
</template>

<script>
import mixinViewModule from '@/mixin/common'
import TaskModal from '@/views/maintenance/TaskManagement/modules/TaskModal'
export default {
  components: {
    TaskModal
  },
  mixins: [mixinViewModule],
  data() {
    return {
      id: '',
      level: '选择报警级别',
      showdeal: false,
      queryUrl: '/pipe-network/remote_water_meter_alarm_messages/page',
      deleteUrl: '/pipe-network/remote_water_meter_alarm_messages/',
      modifyUrl: '/pipe-network/remote_water_meter_alarm_messages',
      visible: false,
      confirmLoading: false,
      list: [],
      query: {
        flowMeterName: '',
        alarmLevel: '',
        alarmIndex: '',
        alarmType: '',
        flowMeterNo: '',
        isDispose: 0,
        msgAddress: '',
        disposeName: '',
        sysTab: 6,
        tenantId: this.$store.state.user.info.tenantId
      },
      resultType: [0, 1],
      zoneTreeData: [],

      typelist: ['重要', '中等', '一般'],
      form: this.$form.createForm(this, { name: 'coordinated' }),
      columns: [
        {
          title: '序号',
          dataIndex: '',
          key: 'rowIndex',
          width: 70,
          align: 'center',
          customRender: function (t, r, index) {
            return parseInt(index) + 1
          }
        },
        {
          title: '片区名称',
          width: 200,
          dataIndex: 'msgAddress',
          align: 'center'
        },
        {
          title: '开始报警时间',
          width: 180,
          dataIndex: 'collectTime',
          align: 'center'
        },
        {
          title: '报警指标',
          width: 100,
          dataIndex: 'alarmType',
          align: 'center'
        },
        {
          title: '报警类型',
          width: 100,
          dataIndex: 'alarmIndex',
          align: 'center'
        },
        {
          title: '夜间总流量',
          width: 200,
          dataIndex: 'prewarningValue',
          align: 'center'
        },
        {
          title: '参考值',
          width: 100,
          dataIndex: 'refValue',
          align: 'center'
        },
        {
          title: '报警次数',
          width: 100,
          dataIndex: 'num',
          align: 'center'
        },
        {
          title: '报警级别',
          width: 100,
          dataIndex: 'alarmLevel',
          align: 'center',
          scopedSlots: { customRender: 'malfunctionLevel' }
        },
        {
          title: '处理状态',
          width: 100,
          dataIndex: 'isDispose',
          align: 'center',
          scopedSlots: { customRender: 'actiontype' }
        },
        {
          title: '处理人',
          width: 100,
          dataIndex: 'disposeName',
          align: 'center'
        },
        {
          title: '处理时间',
          width: 180,
          dataIndex: 'disposeTime',
          align: 'center'
        },
        {
          title: '操作',
          width: 130,
          dataIndex: 'id',
          align: 'center',
          fixed: 'right',
          scopedSlots: { customRender: 'Operation' }
        }
      ],
      treeDefaultExpandedKeys: []

    }
  },
  computed: {
    dualTrackColumns() {
      return [
        {
          title: '序号',
          dataIndex: '',
          key: 'rowIndex',
          width: 70,
          align: 'center',
          customRender: function (t, r, index) {
            return parseInt(index) + 1
          }
        },
        {
          title: '分区名称',
          width: 200,
          dataIndex: 'msgAddress',
          align: 'center'
        },
        {
          title: '开始报警时间',
          width: 180,
          dataIndex: 'collectTime',
          align: 'center'
        },
        {
          title: '流量平均值',
          width: 120,
          dataIndex: 'nightWaterNum',
          align: 'center'
        },
        {
          title: '基线',
          width: 100,
          dataIndex: 'baseLine',
          align: 'center'
        },
        {
          title: '报警级别',
          width: 100,
          dataIndex: 'alarmLevel',
          align: 'center',
          scopedSlots: { customRender: 'malfunctionLevel' }
        },
        {
          title: '处理状态',
          width: 100,
          dataIndex: 'isDispose',
          align: 'center',
          scopedSlots: { customRender: 'actiontype' }
        },
        {
          title: '处理人',
          width: 100,
          dataIndex: 'disposeName',
          align: 'center'
        },
        {
          title: '处理时间',
          width: 180,
          dataIndex: 'disposeTime',
          align: 'center'
        },
        {
          title: '操作',
          width: 200,
          dataIndex: 'id',
          align: 'center',
          fixed: 'right',
          scopedSlots: { customRender: 'DualTrackOperation' }
        }
      ]
    },
    title() {
      return `${this.$store.getters.userInfo.tenant.shortName}智慧管理平台`
    },
    currentUser() {
      return this.$store.getters.userInfo
    },
    token() {
      return this.$store.getters.token
    }
  },
  created() { 
    const sysTab = this.$route.query.sysTab
    if (sysTab != null) {
      this.query.sysTab = Number(sysTab)
    }
    this.getZoneData()

  },
  watch: {
    zoneTreeData (val) {
      this.chuli(val)
    }
  },
  methods: {
    chuli (n) {
      if (n != null && n.length !== 0) {
        n.map((item) => {

          item.children = this.chuli(item.children)

          if (item.level == 1 ) {
            this.treeDefaultExpandedKeys.push(item.id)
          }
        })
        return n
      } else {
        return n
      }
    },
    PublishTask(record) {
      this.currentId = record.id
      this.$refs.TaskModal.edit(record)
    },
    update() {
      const data = {
        id: this.currentId,
        isDispose: 1
      }
      this.$http.put('/pipe-network/remote_water_meter_alarm_messages', data).then(({ data }) => {
        this.queryList()
      })
    },
    LoseSightOf(id) {
      const params = {
        id: id,
        isDispose: 2
      }
      console.log(id, 'ddd')
      this.$confirm({
        title: '忽略',
        content: `您确定要忽略此条数据吗？`,
        centered: true,
        onOk: () => {
          this.$http.put('/pipe-network/remote_water_meter_alarm_messages', params).then((res) => {
            this.isDispose == 2
            this.queryList()
            this.$message.success(`忽略此条数据成功！`)
          })
        }
      })
    },
    getZoneData() {
      this.$http.get('zone-metering/zone-metering').then(({ data }) => {
        this.zoneTreeData = data
      })
    },
    resetList() {
      console.log('reset')
      const sysTab = this.query.sysTab
      this.query = {
        alarmLevel: '',
        alarmIndex: '',
        alarmType: '',
        flowMeterNo: '',
        isDispose: 0,
        flowMeterName: '',
        disposeName: '',
        msgAddress: '',
        sysTab,
        tenantId: this.$store.state.user.info.tenantId
      }
      this.pagination.current = 1
      this.selectedRows = []
      this.queryList()
    },
    handleTabChange (key) {
      this.query.sysTab = Number(key)
      this.selectedRows = []
      this.queryList()
    },
    goToDualTrackChart (record) {
      const zoneId = this.findZoneIdByName(record.msgAddress, this.zoneTreeData)
      if (!zoneId) {
        this.$message.warning('未找到对应的分区信息')
        return
      }
      const moment = require('moment')
      const centerTime = moment(record.collectTime)
      const startTime = centerTime.clone().subtract(3, 'days').format('YYYY-MM-DD')
      const endTime = moment.min(centerTime.clone().add(3, 'days'), moment().endOf('day')).format('YYYY-MM-DD')
      this.$router.push({
        path: '/zone-alarm-management/dual-track-warning',
        query: {
          zoneId: zoneId,
          zoneName: record.msgAddress,
          startTime: startTime,
          endTime: endTime
        }
      })
    },
    findZoneIdByName (name, tree) {
      if (!tree || !name) return null
      for (const node of tree) {
        if (node.zoneName === name) {
          return node.id
        }
        if (node.children && node.children.length > 0) {
          const found = this.findZoneIdByName(name, node.children)
          if (found) return found
        }
      }
      return null
    },
    handleChangeleve(e) {
      this.query.disposeResult = e
    },
    handleChange(e) {
      const params = { id: this.id, malfunctionLevel: e }
      const header = {
        'Content-Type': 'application/json',
        Authorization: this.token
      }
      this.$http({
        url: this.modifyUrl,
        data: params,
        headers: header,
        method: 'put'
      }).then((data) => {
        this.queryList()
        this.visible = false
        this.level = '选择报警级别'
        this.$message.success('标记成功')
      })
    },
    handleSelectChange(value) {
      console.log(value)
      this.form.setFieldsValue({ isDispose: value })
    },
    handleDealSelectChange(value) {
      console.log(value)
      this.form.setFieldsValue({
        disposeResult: value
      })
    },
    Deal(id) {
      this.id = id
      this.showdeal = true
    },
    addOrUpdateHandle(id) {
      this.id = id
      this.showModal()
    },
    showModal() {
      this.visible = true
    },
    handleDealOk() {
      console.log(this.id)
      this.form.validateFields((err, values) => {
        if (!err) {
          const year = new Date().getFullYear()
          let month = new Date().getMonth() + 1
          month = month < 10 ? '0' + month : month
          let day = new Date().getDate()
          day = day < 10 ? '0' + day : day
          let hour = new Date().getHours()
          hour = hour < 10 ? '0' + hour : hour
          let seconds = new Date().getSeconds()
          seconds = seconds < 10 ? '0' + seconds : seconds
          let minutes = new Date().getMinutes()
          minutes = minutes < 10 ? '0' + minutes : minutes
          const now = year + '-' + month + '-' + day + ' ' + hour + ':' + minutes + ':' + seconds
          const params = {
            id: this.id,
            disposeName: values.disposeName,
            alarmContent: values.alarmContent,
            isDispose: 1,
            disposeTime: now
          }
          const header = {
            'Content-Type': 'application/json',
            Authorization: this.token
          }
          this.$http({
            url: this.modifyUrl,
            data: params,
            headers: header,
            method: 'put'
          }).then((data) => {
            this.queryList()
            this.showdeal = false
            this.form.resetFields()
            this.$message.success('处理成功')
          })
        }
      })
    },
    handleDealCancel() {
      this.showdeal = false
    },
    handleOk() {
      this.visible = false
    },
    handleCancel(e) {
      this.visible = false
    },
    deleteSelectRow() {
      if (!this.selectedRows || this.selectedRows.length === 0) {
        return this.$message.warn('请选择要删除的数据')
      }
      const _this = this
      this.$confirm({
        title: `删除提醒`,
        content: `您确认要删除选择的${this.selectedRows.length}条数据吗?`,
        okText: '确认',
        okType: 'danger',
        cancelText: '取消',
        onOk() {
          _this.$http
            .delete(_this.deleteUrl, {
              data: _this.selectedRows,
            })
            .then((res) => {
              if (res.code === 0) {
                _this.$message.success(`共删除${_this.selectedRows.length}条数据`)
                _this.selectedRows = []
                _this.pageQueryList()
              }
            })
            .catch(() => {})
        },
        onCancel() {
          _this.selectedRows = []
          _this.$message.info('已取消删除')
        },
      })
    }
  }
}
</script>

<style lang="less" scoped>
.table-title {
  text-align: left;
  font-size: 16px;
  font-weight: bold;
  margin: 10px 0 20px 20px;
  color: #333;
}
/deep/.table-striped {
  background-color: #fafafa;
}
.alarm-source-tabs {
  margin-top: 16px;
  text-align: left;
}
</style>
